import { useState } from "react";
import type { FormEvent } from "react";
import { categories } from "@/mocks/categories";

interface FilterBarProps {
  activeCategory: string;
  keyword: string;
  resultCount: number;
  onCategoryChange: (slug: string) => void;
  onSearch: (value: string) => void;
}

export default function FilterBar({
  activeCategory,
  keyword,
  resultCount,
  onCategoryChange,
  onSearch,
}: FilterBarProps) {
  const [value, setValue] = useState(keyword);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(value.trim());
  };

  return (
    <div className="rounded-card border border-background-200/80 bg-background-50 p-4 md:p-5">
      <form onSubmit={handleSubmit} className="flex flex-col gap-3 sm:flex-row">
        <div className="relative flex-1">
          <span className="pointer-events-none absolute left-3.5 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
            <i className="ri-search-line text-base"></i>
          </span>
          <input
            type="search"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="搜索话题、人物或关键词…"
            aria-label="搜索话题"
            className="w-full rounded-full border border-background-300/70 bg-background-50 py-2.5 pl-10 pr-4 text-sm text-foreground-900 outline-none transition-colors duration-200 placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
          />
        </div>
        <button
          type="submit"
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-search-2-line text-base"></i>
          </span>
          搜索合集
        </button>
      </form>

      <div className="mt-4 flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => onCategoryChange("")}
          className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors duration-200 ${
            activeCategory === ""
              ? "bg-foreground-950 text-background-50"
              : "border border-background-300/70 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          全部话题
        </button>
        {categories.map((cat) => (
          <button
            key={cat.slug}
            type="button"
            onClick={() => onCategoryChange(cat.slug)}
            className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors duration-200 ${
              activeCategory === cat.slug
                ? "bg-foreground-950 text-background-50"
                : "border border-background-300/70 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      <p className="mt-3 text-xs text-foreground-500">
        共找到 <strong className="text-foreground-800">{resultCount}</strong> 条相关内容
        {keyword && (
          <>
            ，关键词「<strong className="text-foreground-800">{keyword}</strong>」
          </>
        )}
      </p>
    </div>
  );
}